import { queryClient } from "@/lib/query";
import { request } from "@/lib/request";
import { TodoVault } from "@/lib/types";
import { useMutation } from "@tanstack/react-query";

export const useCreateTodoVault = () => {
  return useMutation({
    mutationFn: async (data: { data: { name: string } }) => {
      const res = await request.post<{ data: TodoVault | void }>(
        "/internal/todos/vaults",
        data.data,
      );
      queryClient.invalidateQueries({
        queryKey: ["todos", "vaults"],
      });
      return res.data.data;
    },
  });
};
